export default {"src":"/_next/static/media/logo.2f1b4171.svg","height":173,"width":521,"blurWidth":0,"blurHeight":0};